<template>
  <v-container id="licensePlate" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12">
        <v-slide-group center-active>
          <template v-slot:prev>
            <v-icon x-large>mdi-chevron-left </v-icon>
          </template>

          <template v-slot:next>
            <v-icon x-large>mdi-chevron-right </v-icon>
          </template>

          <v-slide-item
            class="mx-5"
            v-for="(item, idx) in sortedItems"
            :key="idx"
          >
            <CameraItem :type="type" :item="item"></CameraItem>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CameraItem from "@/components/recognition/CameraItem.vue";
import { getInferenceCameras } from "@/endpoint/inferenceCamera";

export default {
  name: "licensePlate",
  components: { CameraItem },
  data() {
    return {
      type: null,
      slide_number: 0,
      inferenceCameraItems: [
        // {
        //   camera_id: "a45612de-9b71-9b19-bea5-f701928c7645",
        //   camera_name: "AXISP1375",
        //   snapshot: require("@/assets/snapshot1.png"),
        //   stream: "",
        // },
        // {
        //   camera_id: "85360528-65fb-211a-adca-af7f67fc6817",
        //   camera_name: "road1",
        //   snapshot: require("@/assets/snapshot2.png"),
        //   stream: "",
        // },
        // {
        //   camera_id: "e8d215a8-f31b-a213-745c-dc922fd1032d",
        //   camera_name: "road2",
        //   snapshot: require("@/assets/snapshot3.png"),
        //   stream: "",
        // },
      ],
    };
  },
  created() {
    this.init(this);
  },
  computed: {
    sortedItems() {
      return [...this.inferenceCameraItems].sort((item1, item2) => {
        if (
          item1.camera.camera_name.toUpperCase() <
          item2.camera.camera_name.toUpperCase()
        )
          return -1;

        if (
          item1.camera.camera_name.toUpperCase() >
          item2.camera.camera_name.toUpperCase()
        )
          return 1;

        return 0;
      });
    },
  },
  methods: {
    async init(scope) {
      scope.type = scope.$route.query.type;
      scope.inferenceCameraItems = await getInferenceCameras();

      return scope;
    },
  },
};
</script>


